import router from "@/routes/index"

export default router
